import { Pipe, PipeTransform } from "@angular/core";
import { stripHTMLTags } from "src/app/support/string";

@Pipe({
  name: "htmlToText",
  standalone: false
})
export class HtmlToTextPipe implements PipeTransform {
  transform(value: string): string {
    return stripHTMLTags(value);
  }
}
